import SparkIcon from "@/assets/icons/24/Spark";
import Accordion from "@/components/Showroom/request-showroom-service/Accordion";
import { Heading } from "@/ui/cva/Heading";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";

type SellingFAQProps = {
  faq?: Record<string, unknown>;
};

export const SellingFAQ = ({ faq }: SellingFAQProps) => {
  const { t } = useTranslation();
  const { locale } = useRouter();

  if (!faq) {
    return null;
  }

  return (
    <section className="flex flex-col items-center">
      <SparkIcon className="h-10  w-10 text-brand-500 md:h-16 md:w-16" />
      <Heading as="h3">{t("common:common-faq-title")}</Heading>
      <Accordion items={faq[locale] ?? []} size="small" />
    </section>
  );
};
